import refs from '../helpers/refs'

class CInputSelect {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    // Input hover states
    this.$refs.input.addEventListener('focus', () => {
      this.$root.classList.add('active')
    })
    this.$refs.input.addEventListener('blur', () => {
      this.$root.classList.remove('active')
    })

    // If input select is set to the default value, make the text grey, if not, make it black
    this.$refs.input.addEventListener('change', () => {
      if (this.$refs.input.value === '') {
        this.$refs.input.classList.add('text-grey-500')
        this.$refs.input.classList.remove('text-grey-800')
      } else {
        this.$refs.input.classList.add('text-grey-800')
        this.$refs.input.classList.remove('text-grey-500')
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.a-input-select')
    .forEach(el => new CInputSelect(el))
})
